import React, { Fragment, PureComponent } from 'react'
import moment from 'moment'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { compose } from 'helpers'

import toggleOpen from 'local_modules/toggleOpen'

import Box from 'components/layout/Box/Box'
import Text from 'components/typography/Text/Text'
import CloseIcon from 'components/ui/CloseIcon/CloseIcon'
import Collapsible from 'components/ui/Collapsible/Collapsible'

import Graph from './Graph/Graph'
import WeatherItem from './WeatherItem/WeatherItem'
import WeatherIcon from './WeatherIcon/WeatherIcon'
import GisMeteoWidget from './GisMeteoWidget/GisMeteoWidget'

import s from './WeatherWidget.scss'


class WeatherWidget extends PureComponent {

  interval = null
  interval2 = null

  state = {
    graphData: null,
  }

  componentDidMount() {
    const { interval } = this.props

    this.interval = setInterval(() => actions.ui.getWeather(), interval)
  }

  componentWillUnmount() {
    const { isToggleActive } = this.props

    clearInterval(this.interval)

    if (isToggleActive) {
      clearInterval(this.interval2)
    }
  }

  fetchFullData = () => {
    actions.ui.getPressure()
    actions.ui.getHumidity()
    actions.ui.getRadiation()
    actions.ui.getLightning()
    actions.ui.getWaterLevel()
  }

  handleClick = () => {
    const { interval, isToggleActive, toggleOpen, toggleClose } = this.props

    if (isToggleActive) {
      toggleClose()
      clearInterval(this.interval2)
    }
    else {
      this.setState({ graphData: null })
      toggleOpen()
      this.fetchFullData()
      this.interval2 = setInterval(() => this.fetchFullData(), interval)
    }
  }

  openGraph = (graphData) => {
    setTimeout(() => this.setState({ graphData }))
  }

  render() {
    const { graphData } = this.state
    const { weatherItems, isToggleActive, setRef } = this.props

    return (
      <span ref={setRef}>
        <Box
          ml="24"
          pl="8"
          pr="8"
        >
          <WeatherIcon
            onClick={this.handleClick}
          />
        </Box>
        <Collapsible className={s.collapsible} collapsed={!isToggleActive}>
          <Box pb="8">
            <div className={s.wrapper}>
              <Box
                className={s.container}
                pt="24"
                pb="24"
              >
                {
                  Boolean(graphData) ? (
                    <Fragment>
                      <div className={s.content}>
                        <Graph
                          data={graphData}
                        />
                        <Box
                          className={s.arrow}
                          pl="24"
                        >
                          <Text
                            message="Назад"
                            size="12-14"
                            onClick={() => this.openGraph(null)}
                          />
                        </Box>
                      </div>
                    </Fragment>
                  ) : (
                    <div className={s.content}>
                      {
                        weatherItems.map(({ title, subTitle, value, isFetching, graphId }, index) => (
                          <WeatherItem
                            key={index}
                            title={title}
                            subTitle={subTitle}
                            value={value}
                            isFetching={isFetching}
                            graphId={graphId}
                            onItemClick={this.openGraph}
                          />
                        ))
                      }
                      <Box pb="40" alignCenter>
                        <Text
                          message="Источник: OpenWeatherMap"
                          size="10-11"
                        />
                      </Box>
                      <GisMeteoWidget />
                    </div>
                  )
                }
                <CloseIcon
                  className={s.close}
                  color="black"
                  onClick={this.handleClick}
                />
              </Box>
            </div>
          </Box>
        </Collapsible>
      </span>
    )
  }
}


export default compose(
  connect({
    weatherItems: (state) => {
      const {
        ui: {
          weather: { temp_max } = {},
          pressure,
          humidity,
          radiation,
          waterLevel,
          lightning,
        },
      } = state

      return [
        {
          title: 'Метеообстановка на',
          value: moment().format('DD.MM.YYYY HH:mm:ss'),
        },
        {
          title: 'Температура воздуха',
          value: `${temp_max}°`,
        },
        {
          title: 'Атмосферное давление',
          value: `${pressure.value} ${pressure.units}`,
          isFetching: pressure.isFetching,
        },
        {
          title: 'Влажность воздуха',
          value: `${humidity.value}${humidity.units}`,
          subTitle: 'Место замера: плотина р.Сатис',
          isFetching: humidity.isFetching,
        },
        // {
        //   title: 'Влажность воздуха',
        //   subTitle: 'Место замера: ул. Полевая',
        //   value: '75%',
        // },
        // TODO get wind direction
        // {
        //   title: 'Направление ветра',
        //   value: 'Северо-западное 302°',
        // },
        {
          title: 'Скорость ветра',
          value: '3м/с',
        },
        {
          title: 'Радиационный фон',
          value: `${radiation.value} ${radiation.units}`,
          isFetching: radiation.isFetching,
          graphId: 'radiation',
        },
        {
          title: 'Уровень воды',
          subTitle: 'Место замера: плотина р.Сатис',
          value: `${waterLevel.value} ${waterLevel.units}`,
          isFetching: waterLevel.isFetching,
          graphId: 'waterLevel',
        },
        {
          title: 'Уровень освещённости',
          value: `${lightning.value} ${lightning.units}`,
          isFetching: lightning.isFetching,
          graphId: 'lightning',
        },
      ]
    }
  }),
  toggleOpen({ toggleOnWindowClick: true }),
)(WeatherWidget)
